var map = {
	"./cert-E-commerce-hkgcsmeaa.jpg": 281,
	"./cert-customer-hkgcsmeaa.jpg": 282,
	"./cert-finance-hkgcsmeaa.jpg": 284,
	"./cert-fsi-hkgcsmeaa.jpg": 286,
	"./cert-general-staff-a-hkgcsmeaa.jpg": 288,
	"./cert-general-staff-hkgcsmeaa.jpg": 290,
	"./cert-general2024-hkgcsmeaa.jpg": 220,
	"./cert-hr-hkgcsmeaa.jpg": 291,
	"./cert-it-hkgcsmeaa.jpg": 292,
	"./cert-market-hkgcsmeaa.jpg": 293,
	"./cert-ngo-hkgcsmeaa.jpg": 294,
	"./cert-senior-manager-hkgcsmeaa.jpg": 296,
	"./cert-startup-hkgcsmeaa.jpg": 297,
	"./cert-student-hkgcsmeaa.jpg": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2939;